import { TAX_GROUP_URL } from '../../CONSTANTS'
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from 'axios'
import Cookies from 'universal-cookie';

const cook = new Cookies().get('loginData1')


const headersdata = {
    'content-type': 'application/json',
    'Accept': 'application/json',
    'Authorization': cook != undefined ? cook.accessToken : ''
    // 'Authorization': url.Auth_Token
}

export const getTaxGroupList = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(TAX_GROUP_URL() + 'getAllRecords', data,  { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getTaxGroupList axios!");
                });
        } catch (error) {
            console.error("in LoginService > getTaxGroupList, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};

export const getAllTaxSansGroup = () => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(TAX_GROUP_URL() + 'getAllTaxSansGroup',  { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getAllTaxSansGroup axios!");
                });
        } catch (error) {
            console.error("in LoginService > getAllTaxSansGroup, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};